import { kuiperClassNames, Button, renderIcon } from '@opallabs/kuiper'
import { styles } from './styles'

const ON_PREM_TWEET_ERROR = `Your Opal settings disallow fetching external link previews.\n
Try again with a link to a piece of content in Opal.`
const ON_PREM_OPAL_ERROR = `Something went wrong when we tried to capture the URL you entered.\n
Please enter a URL of a piece of content in Opal.`

interface Props {
  display: string
  embeddedContentType: string
  isEmbeddedUrl: boolean
  onRefresh: () => void
  onStartOver: () => void
}

export const PreviewError: React.FC<Props> = ({
  display,
  embeddedContentType,
  isEmbeddedUrl,
  onRefresh,
  onStartOver,
}) => {
  const defaultError = `Something went wrong when we tried to capture the URL you entered.\n
  Please enter either a URL of a live ${embeddedContentType} or piece of content in Opal.`
  const isLinkPreviewEnabled =
    (window.ENABLE_LINK_PREVIEWS || '').toString() === 'true'

  return (
    <div css={styles.getErrorWrapper(display)}>
      {renderIcon('alert', { width: 63, height: 60, ariaMode: 'hidden' })}
      <h1 className={kuiperClassNames('error-header')}>Uh oh!</h1>
      <div className={kuiperClassNames('error-text')}>
        {isLinkPreviewEnabled ? (
          <div>{defaultError}</div>
        ) : isEmbeddedUrl ? (
          <div>{ON_PREM_TWEET_ERROR}</div>
        ) : (
          <div>{ON_PREM_OPAL_ERROR}</div>
        )}
      </div>
      <div css={styles.buttonWrapper}>
        <Button
          ariaLabel="Reset"
          type="secondary"
          label="Start Over"
          onClick={onStartOver}
        />
        <Button
          ariaLabel="Refresh"
          type="secondary"
          label="Try Again"
          onClick={onRefresh}
        />
      </div>
    </div>
  )
}
